/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
; (() => {
  // form wrapper
  const forms = document.querySelectorAll('form');
  if (!forms) return;

  forms.forEach(form => {
    if (form.parentNode.classList.contains('frame')) {
      const main = document.querySelector('main > section');

      const parent = form.parentNode;

      const div = document.createElement('div');

      const container = div.cloneNode(false);
      const row = div.cloneNode(false);
      const col = div.cloneNode(false);

      container.classList.add('container-fluid');
      row.classList.add('row');
      col.classList.add('col');

      col.appendChild(parent);
      row.appendChild(col);
      container.appendChild(row);

      main.appendChild(container);
    }
  })

})();

(function () {
  const forms = document.querySelectorAll('.contact-form');
  if (!forms) return;

  const setup = (form) => {
    const lastCol = form.querySelectorAll('.form-container > .row > div[class*="col-"]');
    const actions = form.querySelector('.actions');
    if (!lastCol || !actions) {
      return;
    }
    const row = lastCol[lastCol.length - 1].querySelector(".row");
    if (!row) return;
    row.appendChild(actions);
  };

  forms.forEach((form) => setup(form));
})();

$(document).ready(() => {
  $('select').each(function () {
    let IS_OPEN = false;

    const SELECT_INPUT = $(this);

    $(this).wrap('<div class="custom-select">');

    const selectList = document.createElement('ul');
    selectList.className = 'custom-select-list';

    const selectTitle = document.createElement('div');
    selectTitle.className = 'custom-select-title-wrapper';

    const selectTitleCurrent = document.createElement('span');
    selectTitleCurrent.className = 'custom-select-title';

    const select = $(this).parent();
    const option = $(this).find($('option'));

    selectTitleCurrent.textContent = SELECT_INPUT.data('placeholder') || $(option)[0].textContent;

    selectTitle.append(selectTitleCurrent);

    const icon = document.createElement('i');
    icon.className = 'material-icons-outlined';
    icon.textContent = 'expand_more';

    selectTitle.append(icon);

    const hideSelect = () => {
      if (!IS_OPEN) return;

      select.find($('.custom-select-list')).hide(0);
      select.find($('i')).removeClass("active");
      $('.custom-select-body-overlay').remove();
      IS_OPEN = false;
    }

    $(document).click(() => {
      hideSelect();
    });

    $(select).click((e) => {
      e.stopPropagation();
    });

    select.prepend(selectTitle, selectList);

    for (i = 0; i < option.length; i++) {
      const selectLi = document.createElement('li');
      selectList.append(selectLi);
      selectLiOption = select.find($('.custom-select-list li'));

      if (option.eq(i).text().length < 2) {
        $('.custom-select-title').css('width', '200px');
      }
      selectLiOption.eq(i).text(option.eq(i).text());

      if (option.eq(i).attr('selected')) {
        selectLiOption.eq(i).addClass('selected');
        select.find($('.custom-select-title')).text(selectLiOption.eq(i).text());
      }

      selectLiOption.eq(i).click(function () {
        $(this).addClass('selected').siblings().removeAttr('class');
        const index = $(this).index();

        hideSelect();

        option.eq(index).prop('selected', 'selected').siblings().removeAttr('selected');
        select.find($('.custom-select-title')).text($(this).text());
        option.trigger('change');

        $(SELECT_INPUT).get().forEach(x => {
          x.dispatchEvent(new Event('change'));
        });
      });
    }

    $(selectList).hide(0);



    select.find($('.custom-select-title-wrapper')).click(() => {
      select.find($('.custom-select-list')).toggle(0);
      select.find($('i')).toggleClass("active");

      IS_OPEN = true;

      const bodyOverlay = document.createElement('div');
      bodyOverlay.className = 'custom-select-body-overlay';
      $('body').prepend(bodyOverlay);

      $('.custom-select-body-overlay').click(() => {
        select.find($('.custom-select-list')).toggle(0);
        select.find($('i')).toggleClass("active");
        $('.custom-select-body-overlay').remove();
        IS_OPEN = false;
      });
    });
  });
});

if (window.Parsley) {
  window.Parsley.on("form:error", formInstance => {
    let elementOffset,
        scrolled = false;

    for (const field of formInstance.fields) {
      const element = field.element;

      if (field.validationResult !== true) {
        const selectWrapper = element.closest(".custom-select"),
            radioTextWrapper = element.closest(".radio-toggle-items");

        if (element.tagName === "SELECT" && selectWrapper) {
          elementOffset = selectWrapper.offsetTop;
          selectWrapper.classList.add("parsley-error");
        } else if (element.classList.contains("form-radio-text") && radioTextWrapper) {
          // Handling of the RadioText validation
          elementOffset = radioTextWrapper.offsetTop;
          radioTextWrapper.classList.add("parsley-error");
        } else {
          elementOffset = element.offsetTop;
        }

        if (scrolled === false) {
          window.scrollTo({
            top: elementOffset,
            behavior: "smooth"
          });

          scrolled = true;
        }
      }
    }
  });

  window.Parsley.on("field:success", field => {
    const element = field.element,
        selectWrapper = element.closest(".custom-select"),
        radioTextWrapper = element.closest(".radio-toggle-items");

    if (element.tagName === "SELECT" && selectWrapper) {
      selectWrapper.classList.remove("parsley-error");
    } else if (element.classList.contains("form-radio-text") && radioTextWrapper) {
      radioTextWrapper.classList.remove("parsley-error");
    }
  });
}

